<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6" style="border-top: solid #6c757d 4px;">
    <!-- Simple Header -->
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900">Datenschutzerklärung</h1>
      <p class="text-gray-600">Informationen zum Datenschutz gemäß DSGVO</p>
    </div>

    <!-- Content -->
    <div>
      <div class="prose prose-lg max-w-none">
          <!-- Introduction -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">1. Datenschutz auf einen Blick</h2>
            <div class="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-400">
              <h3 class="text-lg font-semibold text-blue-800 mb-2">Allgemeine Hinweise</h3>
              <p class="text-blue-700">Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.</p>
            </div>
          </div>

          <!-- Data Collection -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">2. Datenerfassung auf dieser Website</h2>
            <div class="space-y-4 text-gray-700">
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h3>
                <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.</p>
              </div>
              
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Wie erfassen wir Ihre Daten?</h3>
                <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
                <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.</p>
              </div>

              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Wofür nutzen wir Ihre Daten?</h3>
                <p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>
              </div>

              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Welche Rechte haben Sie bezüglich Ihrer Daten?</h3>
                <p>Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p>
              </div>
            </div>
          </div>

          <!-- Responsible Party -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">3. Hinweis zur verantwortlichen Stelle</h2>
            <div class="bg-gray-50 p-6 rounded-lg">
              <p class="text-gray-700 mb-4">Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <div class="space-y-2 text-gray-700">
                <p><strong>Labor C Webengineering GmbH</strong></p>
                <p>Pappenheimgasse 33/10</p>
                <p>1200 Wien</p>
                <p>Österreich</p>
                <p class="mt-4">Telefon: +43 1 890 39 54</p>
                <p>E-Mail: <a href="mailto:datenschutz&#64;labor-c.net" class="text-blue-600 hover:text-blue-800">datenschutz&#64;labor-c.net</a></p>
              </div>
            </div>
          </div>

          <!-- Data Collection Details -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">4. Datenerfassung auf dieser Website</h2>
            <div class="space-y-6 text-gray-700">
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Server-Log-Dateien</h3>
                <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>
                <ul class="list-disc list-inside mt-2 ml-4">
                  <li>Browsertyp und Browserversion</li>
                  <li>verwendetes Betriebssystem</li>
                  <li>Referrer URL</li>
                  <li>Hostname des zugreifenden Rechners</li>
                  <li>Uhrzeit der Serveranfrage</li>
                  <li>IP-Adresse</li>
                </ul>
                <p class="mt-2">Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.</p>
              </div>

              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Kontaktformular</h3>
                <p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
                <p class="mt-2">Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).</p>
              </div>

              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-2">Anfrage per E-Mail, Telefon oder Telefax</h3>
                <p>Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
              </div>
            </div>
          </div>

          <!-- Cookies -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">5. Cookies</h2>
            <div class="space-y-4 text-gray-700">
              <p>Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (dauerhafte Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Dauerhafte Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.</p>
              
              <p>Teilweise können auch Cookies von Drittunternehmen auf Ihrem Endgerät gespeichert werden, wenn Sie unsere Seite betreten (Third-Party-Cookies). Diese ermöglichen uns oder dem Werbepartner, bestimmte Informationen (z. B. IP-Adresse, Browser-Identifikation, Website-Adresse) an ein Drittland zu übertragen und dort zu speichern.</p>

              <p>Diese Cookies werden automatisch nach einer vordefinierten Zeit gelöscht, die sich je nach Cookie unterscheiden kann. In den einzelnen Cookie-Einstellungen Ihres Browsers können Sie die Cookies verwalten und löschen.</p>
            </div>
          </div>

          <!-- Your Rights -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">6. Ihre Rechte</h2>
            <div class="bg-green-50 p-6 rounded-lg border-l-4 border-green-400">
              <h3 class="text-lg font-semibold text-green-800 mb-4">Sie haben folgende Rechte:</h3>
              <ul class="list-disc list-inside space-y-2 text-green-700">
                <li><strong>Recht auf Auskunft</strong> über die von uns verarbeiteten personenbezogenen Daten</li>
                <li><strong>Recht auf Berichtigung</strong> unrichtiger oder unvollständiger Daten</li>
                <li><strong>Recht auf Löschung</strong> Ihrer bei uns gespeicherten personenbezogenen Daten</li>
                <li><strong>Recht auf Einschränkung der Verarbeitung</strong> Ihrer personenbezogenen Daten</li>
                <li><strong>Recht auf Datenübertragbarkeit</strong> Ihrer personenbezogenen Daten</li>
                <li><strong>Widerspruchsrecht</strong> gegen die Verarbeitung Ihrer personenbezogenen Daten</li>
                <li><strong>Recht auf Widerruf</strong> einer erteilten Einwilligung</li>
                <li><strong>Beschwerderecht</strong> bei der zuständigen Aufsichtsbehörde</li>
              </ul>
            </div>
          </div>

          <!-- Data Security -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">7. Datensicherheit</h2>
            <div class="space-y-4 text-gray-700">
              <p>Wir verwenden innerhalb des Website-Besuchs den verbreiteten SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. In der Regel handelt es sich dabei um eine 256 Bit Verschlüsselung. Falls Ihr Browser keine 256 Bit Verschlüsselung unterstützt, greifen wir auf 128 Bit v3 Technologie zurück.</p>
              
              <p>Ob eine einzelne Seite unseres Internetauftritts verschlüsselt übertragen wird, erkennen Sie an der geschlossenen Darstellung des Schlüssel- beziehungsweise Schloss-Symbols in der unteren Statusleiste Ihres Browsers.</p>

              <p>Wir bedienen uns im Übrigen geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.</p>
            </div>
          </div>

          <!-- Contact -->
          <div class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">8. Kontakt</h2>
            <div class="bg-gray-50 p-6 rounded-lg">
              <p class="text-gray-700 mb-4">Bei Fragen zum Datenschutz wenden Sie sich bitte an:</p>
              <div class="space-y-2 text-gray-700">
                <p><strong>Datenschutzbeauftragter</strong></p>
                <p>Labor C Webengineering GmbH</p>
                <p>Pappenheimgasse 33/10</p>
                <p>1200 Wien, Österreich</p>
                <p>E-Mail: <a href="mailto:datenschutz&#64;labor-c.net" class="text-blue-600 hover:text-blue-800">datenschutz&#64;labor-c.net</a></p>
              </div>
            </div>
          </div>

          <!-- Last Updated -->
          <div class="text-sm text-gray-500 border-t pt-4">
            <p>Stand: Januar 2025</p>
          </div>
      </div>
    </div>
  </div>
</div>
